import React from 'react';
import { observer } from 'mobx-react-lite';
import CopilotBodyItem from './CopilotBodyItem/CopilotBodyItem';
import Sentiments from './Sentiments/Sentiments';
import { useStore } from '@/stores';

import './CopilotBody.scss';

const CopilotBody = observer(() => {
  const {
    transcriptStore: { currentSessionsAnalytics },
  } = useStore();
  const {
    callTranscript,
    callSummary,
    callSentiment,
    redactedCallTranscript,
    redactedCallSummary,
  } = currentSessionsAnalytics;

  const transcript = callTranscript?.text?.trim?.()
    ? callTranscript.text
    : (redactedCallTranscript?.text ?? '');
  const summary = callSummary?.text?.trim?.()
    ? callSummary.text
    : (redactedCallSummary?.text ?? '');

  return (
    <div className="solgari-copilot-body">
      <CopilotBodyItem title="Transcript" subject={transcript} />
      <CopilotBodyItem title="Summary" subject={summary} />
      <Sentiments callSentiment={callSentiment} />
    </div>
  );
});

export default CopilotBody;
